import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Image from 'Component/Image';
import Popup from 'Component/Popup';
import { ProductType } from 'Type/ProductList.type';

import { ADDED_PRODUCT_POPUP_ID } from './AddToCartPopUp.config';

import './AddToCartPopUp.style';

/** @namespace Bodypwa/Component/AddToCartPopUp/Component */
export class AddToCartPopUpComponent extends PureComponent {
    static propTypes = {
        product: ProductType.isRequired,
        originalProduct: ProductType.isRequired,
        continueShopping: PropTypes.func.isRequired,
        goToCheckout: PropTypes.func.isRequired
    };

    render() {
        const {
            originalProduct: { name }, product: { image: { url } = {} } = {}, continueShopping, goToCheckout
        } = this.props;

        return (
            <Popup
              mix={ { block: 'AddToCartPopUp' } }
              id={ ADDED_PRODUCT_POPUP_ID }
              checkmark
            >
              <p block="AddToCartPopUp" elem="Name">
                { name }
              </p>
              <Image
                block="AddToCartPopUp"
                elem="Image"
                ratio="custom"
                src={ url }
              />
               <div block="AddToCartPopUp" elem="CheckoutButtonWrapper">
                  <button
                    block="AddToCartPopUp"
                    elem="CheckoutButton"
                    onClick={ goToCheckout }
                    mix={ { block: 'Button' } }
                  >
                      { __('Checkout') }
                  </button>
                  <botton onClick={ continueShopping } block="AddToCartPopUp" elem="Link">
                      { __('Continue shopping') }
                  </botton>
               </div>
            </Popup>
        );
    }
}

export default AddToCartPopUpComponent;
